import { type Browser, type OperatingSystem } from 'owa-user-agent';
import type { SupportedBrowserConfig } from '../schema/A2HSSupportedBrowserConfig';

export const getSupportedBrowserConfigs = (): SupportedBrowserConfig[] => [
    // Android - Chrome: [45, 68), >=76
    /**
     * Caveat:
     * Versions in [68,76) are not being supported because 'beforeInstallPromptEvent.preventDefault()'
     * doesn't let us suppress the browser default mini-infobar banner for A2HS. Associated links:
     *      1. https://developers.google.com/web/updates/2018/06/a2hs-updates
     *      2. https://developers.google.com/web/updates/2019/07/nic76
     */
    {
        browserName: 'Chrome',
        browserVersionRange: [[45], [68]],
        operatingSystem: 'Android',
    },
    {
        browserName: 'Chrome',
        browserVersionRange: [[76]],
        operatingSystem: 'Android',
    },

    // Android - Edge Anaheim: all versions
    {
        browserName: 'Edge Anaheim',
        operatingSystem: 'Android',
    },

    // iOS - Safari: >= 13
    {
        browserName: 'Safari',
        browserVersionRange: [[13]],
        operatingSystem: 'iOS',
    },

    // iOS - Chrome: iOS version >= 16.4
    // Chrome version >= 113 https://pushalert.co/blog/google-chrome-ios-supports-web-push-notifications-v113/
    {
        browserName: 'Chrome',
        browserVersionRange: [[113]],
        operatingSystem: 'iOS',
        operatingSystemsVersionRange: [[16, 4]],
    },

    // iOS - Edge Anaheim: iOS version >= 16.4
    // Edge version >= 120
    // Not able to find the exact version of Edge Anaheim that supports A2HS
    // hence using 6 month older version of Edge Anaheim after iOS 16.4
    {
        browserName: 'Edge Anaheim',
        browserVersionRange: [[120]],
        operatingSystem: 'iOS',
        operatingSystemsVersionRange: [[16, 4]],
    },
];
